import { Link } from "react-router-dom";
import "./Auth.css";

function SignIn() {
  return (
    <div className="auth-container">
      <div className="vintage-corner corner-tl"></div>
      <div className="vintage-corner corner-tr"></div>
      
      <div className="auth-box">
        <div className="auth-header">
          <div className="auth-logo">
            <div className="logo-icon">H</div>
            <div className="logo-text">Haqtri</div>
          </div>
          <h2>Welcome Back</h2>
          <p>Access your premium real estate dashboard</p>
        </div>
        
        <form className="auth-form">
          <div className="form-group">
            <label>Email</label>
            <input type="email" placeholder="Enter your email" required />
            <i className="fas fa-envelope"></i>
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" placeholder="Enter your password" required />
            <i className="fas fa-lock"></i>
          </div>
          
          <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" />
              <span className="checkmark"></span>
              Remember me
            </label>
            <a href="#" className="forgot-password">Forgot password?</a>
          </div>
          
          <button type="submit" className="auth-btn">
            <span>Sign In</span>
            <i className="fas fa-arrow-right"></i>
          </button>
        </form>
        
        <div className="auth-divider">
          <span>Or continue with</span>
        </div>
        
        <div className="social-auth">
          <button className="social-btn google-btn">
            <i className="fab fa-google"></i>
            Google
          </button>
          <button className="social-btn facebook-btn">
            <i className="fab fa-facebook-f"></i>
            Facebook
          </button>
        </div>
        
        <p className="auth-footer">
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </p>
      </div>
      
      <div className="vintage-corner corner-bl"></div>
      <div className="vintage-corner corner-br"></div>
    </div>
  );
}

export default SignIn;